<template>
  <div class="container tem021">
    <HeadingOne class="-margin-md">秘密のことば設定</HeadingOne>

    <WizardGroup class="-margin-md">
      <MainWizard :active-index="2" type="secret"></MainWizard>
    </WizardGroup>

    <NoticeBox class="-success">
      <NoticeBody
        >秘密のことばの設定が完了いたしました。<br />引き続き、ご契約内容のご確認画面へお進みください。</NoticeBody
      >
    </NoticeBox>

    <BtngroupSingle class="-margin-lg">
      <BtnMain class="-main -md" router-name="en012">
        ご契約内容のご確認へ
      </BtnMain>
    </BtngroupSingle>
  </div>
</template>

<script>
import { setMeta } from "@/utils/Meta";
import HeadingOne from "@/components/heading/HeadingOne";
import WizardGroup from "@/components/wizard/WizardGroup";
import MainWizard from "@/components/wizard/MainWizard";
import NoticeBody from "@/components/box/NoticeBody";
import NoticeBox from "@/components/box/NoticeBox";
import BtngroupSingle from "@/components/button/BtngroupSingle";
import BtnMain from "@/components/button/BtnMain";
export default {
  name: "Tem021",
  components: {
    BtnMain,
    BtngroupSingle,
    NoticeBody,
    NoticeBox,
    MainWizard,
    WizardGroup,
    HeadingOne,
  },
  setup() {
    setMeta({
      title: "秘密のことば設定完了",
      description:
        "au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。",
      keywords:
        "au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,入会,秘密のことば",
    });
  },
};
</script>

<style scoped></style>
